// Important to not run the interval under 500ms,
// otherwise the CPU will suffer in performance
const POLL_INTERVAL = 500;
let prevCookie;
let callbacks = [];

// eslint-disable-next-line @cbhq/no-module-side-effects -- TODO Fix this
if (typeof window !== 'undefined') {
  prevCookie = document.cookie;
  setInterval(() => {
    if (prevCookie !== document.cookie) {
      prevCookie = document.cookie;
      callbacks.forEach(callback => callback());
    }
  }, POLL_INTERVAL);
}
function onCookieChanged(callback) {
  callbacks.push(callback);
  return () => {
    callbacks = callbacks.filter(cb => cb !== callback);
  };
}
export { onCookieChanged as default };
//# sourceMappingURL=onCookieChanged.js.map
